import React from 'react';

export default function MergeBylaws() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-12">
      <h3 className="text-xl font-semibold mb-2">Merge your existing bylaws</h3>
      <p className="text-muted-foreground">Guidance and mapping process overview.</p>
    </section>
  );
}
